import { render } from "./info.vue?vue&type=template&id=544d6daa&scoped=true&ts=true"
import script from "./info.ts?vue&type=script&scoped=true&lang=ts"
export * from "./info.ts?vue&type=script&scoped=true&lang=ts"

import "./info.vue?vue&type=style&index=0&id=544d6daa&scoped=true&lang=scss"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544d6daa"]])

export default __exports__